export default "__VITE_ASSET__Db1ZWVhP__"